import {connect} from 'react-redux';

import CapacityAvailabilityForm from './CapacityAvailabilityForm.jsx';

import {
  validate,
  handleCapacitySave
} from './actions';

import {hideCapacityDialog} from './actionTypes';

const mapStateToProps = state => ({
  validate: validate,
  eventTypes: state.tournament.capacity.eventTypes
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(handleCapacitySave(data)),
  onCancel: () => dispatch(hideCapacityDialog())
});

export default connect(mapStateToProps, mapDispatchToProps)(CapacityAvailabilityForm);



// WEBPACK FOOTER //
// ./src/features/tournament/capacity/CapacityAvailabilityFormContainer.jsx